document.addEventListener('DOMContentLoaded', function() {
    const dtcSikaChip = document.querySelector('#sika-chip');
    if (!!!dtcSikaChip) return 

    const dtcSikaChipNewElement = document.createElement('div');
    dtcSikaChipNewElement.classList.add('dtc-sika-chip');
    dtcSikaChipNewElement.innerHTML = `
        <div class="dtc-sika-chip__wrapper">
            <p>Save money on your purchase with tax-free funds.</p>
        </div>
    `

    addDtcChanges()

    const config = { attributes: true, childList: true, subtree: true };
    const observer = new MutationObserver((mutationList, observer) => {
        for (const mutation of mutationList) {
            addDtcChanges()
            observer.disconnect();
        }
    });
    observer.observe(dtcSikaChip, config);

    function addDtcChanges() {
        dtcSikaChip.appendChild(dtcSikaChipNewElement);
        const dtcSikaChipImg = document.querySelector('#sika-chip img');
        if (!!!dtcSikaChipImg) return
        dtcSikaChipImg.src = window.innerWidth > 768
            ? 'https://cdn.shopify.com/s/files/1/0013/6698/2692/files/hsa-banner-desktop.svg?v=1727968425'
            : 'https://cdn.shopify.com/s/files/1/0013/6698/2692/files/hsa-banner-mobile.svg?v=1727968425'
    }
})